import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/Pricing.module.css';

const tiers = [
  {
    label: '월 매출 1천만원 이하',
    rate: '2.0',
    unit: '%',
    note: 'PG 수수료 (3.3% 제외)'
  },
  {
    label: '월 매출 3천만원 이하',
    rate: '1.5',
    unit: '%',
    note: 'PG 수수료 (3.3% 제외)'
  },
  {
    label: '월 매출 3천만원 이상',
    rate: '맞춤견적',
    unit: '',
    note: '비용 절감을 위한 고정비 전환'
  }
];

export default function Pricing() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="pricing" ref={ref} className={`section ${styles.pricing}`}>
      <div className="section-content">
        <h2 className={`text-center ${styles.title}`}>월 구독료 0원 + 업계 최저 수수료</h2>

        <div className={`${styles.tiers} ${isVisible ? styles.visible : ''}`}>
          {tiers.map((tier, index) => (
            <div
              key={index}
              className={styles.tier}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <p className={styles.tierLabel}>{tier.label}</p>
              <div className={styles.rate}>
                {tier.rate}
                {tier.unit && <span className={styles.unit}>{tier.unit}</span>}
              </div>
              <p className={styles.tierNote}>{tier.note}</p>
            </div>
          ))}
        </div>

        <p className={`${styles.tagline} text-center`}>
          센터 성장을 지원하기 위한 수수료 감소/비용 절감 Plan
        </p>

        <p className={`${styles.footnote} text-center`}>
          단월 스파이크/시즌성을 고려해서 최근 3개월 평균으로 산정 (협의 가능)
        </p>
      </div>
    </section>
  );
}
